import type { IconSvgObject } from './types';

const ZodiacCapricornIcon: IconSvgObject = [
  ["path", { d: "M2.99979 4C4.62074 4 5.93478 5.31404 5.93478 6.935V17.4783", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5.93359 17.4783V8.03271C5.93359 5.8055 7.7391 4 9.96631 4C12.1935 4 13.999 5.80551 13.999 8.03271V17C13.999 18.6569 12.6559 20 10.999 20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M21 15.5C21 17.433 19.433 19 17.5 19C15.567 19 14 17.433 14 15.5C14 13.567 15.567 12 17.5 12C19.433 12 21 13.567 21 15.5Z", stroke: "currentColor", strokeWidth: "1.5", key: "2" }]
];

export default ZodiacCapricornIcon;
